import { render, staticRenderFns } from "./UploadReport.vue?vue&type=template&id=05b451b6"
import script from "./UploadReport.vue?vue&type=script&lang=js"
export * from "./UploadReport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports